import { OpenInNewTab } from "../../utils/OpenInNewTab";

export const LinkViewer = ({ icon: Icon, value }) => (
  <div className="flex mb-2">
    <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
      <Icon />
    </span>
    <span
      onClick={() => value && OpenInNewTab(value)}
      className={`text-xs rounded-l-none rounded-r-lg bg-gray-50 border block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5 ${
        value ? 'text-blue-600 hover:underline cursor-pointer' : 'text-gray-900'
      }`}
    >
      {value || "Sin link"}
    </span>
  </div>
);
